import { UPDATE_ACTIVE_FOLDER,UPDATE_OPEN_OR_CLOSE_FOLDER,
    ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU,ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU_CHILD,
    ADMIN_ACTVE_MENU,USER_GET_INTERFACE
} from "./Contant"

import { ISCLOSED,ADMIN_DASHBOARD } from "./Values"
const initState={
    todosCT:[],
    todoInputCT:'',
    activeFolderCT:{
        cap1:0,
        cap2:0,
        cap3:0
    },
    openOrCloseFolderCT:{ 
        cap1:[0],
        cap2:[0],
        cap3:[0]},
    adminOpenOrCloseverticalMenu:true,
    adminOpenOrCloseverticalMenuChild:ISCLOSED,
    adminActiveMenu:ADMIN_DASHBOARD,
    userInterface:[],
    userInterfacePopup:[],
    userInterfaceBanner:[],
    userInterfaceAbout:[],
    userInterfaceAboutMessage:[],
    userInterfaceAboutStrategy:[],
    userInterfaceAboutPrise:[]
}
function reducer(state,action){
    switch(action.type){
        case UPDATE_ACTIVE_FOLDER:
            return{
                ...state,
                activeFolderCT:action.payload
            }
        case UPDATE_OPEN_OR_CLOSE_FOLDER:
            return{
                ...state,
                openOrCloseFolderCT:action.payload
            }
        case ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU:
            return{
                ...state,
                adminOpenOrCloseverticalMenu:action.payload
            }
        case ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU_CHILD:
            return{
                ...state,
                adminOpenOrCloseverticalMenuChild:action.payload
            }
        case ADMIN_ACTVE_MENU:
            return{
                ...state,
                adminActiveMenu:action.payload
            }
        case USER_GET_INTERFACE:
            return{
                ...state,
                userInterface:action.payload,
                userInterfacePopup:action.payload.filter((item)=>{
                    return item.Interface_Type==='POPUP'
                }),
                userInterfaceBanner:action.payload.filter((item)=>{
                    return item.Interface_Type==='BANNER'
                }),
                userInterfaceAbout:action.payload.filter((item)=>{
                    return item.Interface_Type==='ABOUT'
                }),
                userInterfaceAboutMessage:action.payload.filter((item)=>{
                    return item.Interface_Type==='MESSAGE'
                }),
                userInterfaceAboutStrategy:action.payload.filter((item)=>{
                    return item.Interface_Type==='STRATEGY'
                }),
                userInterfaceAboutPrise:action.payload.filter((item)=>{
                    return item.Interface_Type==='PRISE'
                }),
            }
        default:
            throw new Error('Invalid action.')
    }
}

export {initState}
export default reducer